import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Error500 from '../../../components/error-500/error-500'

export class Error500Page extends Component {
  render() {
    return (
      <div>
        <Error500 {...this.props} />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(null, mapDispatchToProps)(
  translate()(Error500Page),
)



// WEBPACK FOOTER //
// ./src/containers/pages/error-500-page/error-500-page.js